/**
 * @Author: Zero
 * @Date: 2024-03-07 10:18:57
 * @Explain: 导出历史
 */
import http from '../http';
import { onAddReq } from './data.d';

const MODEL = '/businessUser';

export default {
  // 导出联系人- 新增 (此接口在别处有使用)
  onAdd(data: onAddReq) {
    return http.post(
      `${MODEL}/create-export-history`,
      {
        ...data,
        isExportCenter: true,
      },
      {
        params: { switchReqToUnderline: true },
      },
    );
  },
};
